import React, { useEffect, useState } from "react";
import { Row, Col, Card, Spin, Space, Typography } from "antd";
import { Link } from "react-router-dom";
import Title from "antd/es/typography/Title";
import { apiCaller } from "src/util/apiCaller";
import {
  UserOutlined,
  CalendarOutlined,
  FolderOpenOutlined,
  DoubleRightOutlined,
} from "@ant-design/icons";

const { Text, Paragraph } = Typography;

interface DocumentData {
  idTulieu: string;
  anhDaiDien: string;
  tenTuLieu: string;
  moTa: string;
  historicalPeriod?: string;
  culturalType?: string;
  productType?: string;
  location?: string;
  tacGia?: string;
  ngayDang?: string;
}

const useFetchDocuments = (page: number) => {
  const [loading, setLoading] = useState(true);
  const [documents, setDocuments] = useState<DocumentData[]>([]);

  const fetchDocuments = async () => {
    setLoading(true);
    try {
      const response = await apiCaller({
        url: `/apipublic/tulieuhienthis?istulieu=true&page=${page}&size=4&properties_sort=id&type_sort=desc`,
        method: "GET",
      });

      if (response?.data) {
        const { content } = response.data;
        const formattedDocuments = content.map((doc: any) => ({
          idTulieu: doc.id,
          anhDaiDien: doc.anhDaiDien,
          tenTuLieu: doc.tenTuLieu,
          moTa: doc.moTa,
          historicalPeriod: doc.loaiTuLieu.tenLoaiTuLieu || "",
          culturalType: doc.culturalType,
          productType: doc.productType,
          location: doc.location,
          tacGia: doc.tacGia,
          ngayDang: doc.ngayDang,
        }));

        setDocuments(formattedDocuments);
      }
    } catch (error) {
      console.error("Error fetching documents:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDocuments();
  }, [page]);

  return { documents, loading };
};

const TuLieuSliderHome: React.FC = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const { documents, loading } = useFetchDocuments(currentPage);

  if (loading && documents.length === 0) {
    return (
      <div style={{ textAlign: "center", padding: "20px" }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div style={{ marginBottom: "20px" }} className="QTI-list-detail-container">
      <Title level={2} className="QTI-slider-home-title" >
        Tư liệu
        <div
          style={{
            textAlign: "right",
            marginTop: 18,
            fontSize: 13,
            fontStyle: "italic",
            color: "#1677ff",
          }}
        >
          <Link to={`/trang-chu/tu-lieu`} onClick={() => localStorage.setItem("currentMenuKey", "tu-lieu")}>
            Xem thêm <DoubleRightOutlined />
          </Link>
        </div>
      </Title>

      <Row gutter={[16, 16]}>
        {documents.slice(0, 4).map((document) => (
          <Col xs={24} sm={12} md={6} lg={6} key={document.idTulieu}>
            <Link
              to={`/trang-chu/tu-lieu/${document.idTulieu}/chi-tiet`}
              onClick={() => localStorage.setItem("currentMenuKey", "tu-lieu")}
            >
              <Card
                className="QTI-slider-home-card"
                hoverable
                style={{ padding: "12px" }}
                cover={
                  <div className="QTI-slider-home-card__cover">
                    <img alt={document.tenTuLieu} src={document.anhDaiDien} />
                  </div>
                }
              >
                <Card.Meta
                  className="card-meta-custom"
                  title={document.tenTuLieu}
                  description={
                    <Space size={16}>
                      {document.tacGia && (
                        <Text strong style={{ fontSize: "12px" }}>
                          <UserOutlined />
                          {document.tacGia}
                        </Text>
                      )}
                      {document.ngayDang && (
                        <Text type="secondary" style={{ fontSize: "12px" }}>
                          <CalendarOutlined />{" "}
                          {new Date(document.ngayDang).toLocaleDateString(
                            "vi-VN"
                          )}
                        </Text>
                      )}
                      {document.historicalPeriod && (
                        <Text type="secondary" style={{ fontSize: "12px" }}>
                          <FolderOpenOutlined /> {document.historicalPeriod}
                        </Text>
                      )}
                    </Space>
                  }
                />
                <Paragraph type="secondary" className="QTI-mota-trang-chu">
                  {document.moTa}
                </Paragraph>
              </Card>
            </Link>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default TuLieuSliderHome;
